import {
  CarePlanCell,
  MetricsCell,
  ClipboardListButtonCell,
  MessageButtonCell,
} from '../../components';
import {
  Box as MuiBox,
  TableCell as MuiTableCell,
  TableRow,
} from '@mui/material';
import PatientActions from './PatientActions';
import getPermission from 'lib/utils/getPermission';
import TableUserInfo from 'components/TableUserInfo';
import { useHistory, useLocation } from 'react-router-dom';
import { careTeamMemberRouteTemplates } from 'routing/routeTemplates';
import { IconButton } from 'components/ui';

interface IProps {
  patient: any;
  graphDialog: any;
  setMetricForGraph: any;
  id: string | number;
  isHome: boolean | null | undefined;
  handleDeletePatient: Function;
}

export function PatientRow({ patient, isHome, handleDeletePatient }: IProps) {
  const { id, carePlans, isActive } = patient;
  const history = useHistory();
  const location = useLocation();
  function handleCellClick(e: any) {
    e.stopPropagation();

    if (isActive) {
      if (getPermission('PATIENT_PROFILE', 'read')) {
        history.push(`/patientRecord/${patient.id}`, {
          from: {
            pathname: location.pathname,
            search: location.search,
            fullUrl: location.pathname + location.search,
            title: 'Patients',
          },
        });
      }
    }
  }

  return (
    // @ts-ignore
    <TableRow
      key={id}
      id={id}
      data-id={id}
      style={{
        width: '100%',
      }}
    >
      <MuiTableCell
        width={'30%'}
        style={{
          filter: isActive ? 'none' : 'grayscale(100%)',
          opacity: isActive ? 1 : 0.8,
        }}
      >
        <TableUserInfo
          user={patient}
          isPatient
          isActive={isActive}
          //@ts-ignore
          onCellClick={handleCellClick}
        />
      </MuiTableCell>

      <MuiTableCell
        style={{
          filter: isActive ? 'none' : 'grayscale(100%)',
          opacity: isActive ? 1 : 0.8,
        }}
        width={'70%'}
      >
        <div
          style={{
            maxHeight: '150px',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          {carePlans &&
            carePlans.items.map((item: any, idx: number) => (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: 10,
                  }}
                >
                  <CarePlanCell carePlan={item} />
                  {item.metrics && (
                    <MetricsCell
                      metrics={item.metrics}
                      id={id}
                      isActive={isActive}
                    />
                  )}
                </div>

                <ClipboardListButtonCell
                  style={{ height: '100%' }}
                  engagement={item.engagementRatio}
                />
              </div>
            ))}
        </div>
      </MuiTableCell>

      {!isHome && (
        <MuiTableCell>
          <MuiBox display="flex" ml="auto">
            {/* <MessageButtonCell patientId={id} /> */}
            {handleDeletePatient
              ? getPermission('PATIENT_GROUPS', 'update') && (
                  <IconButton
                    icon="ban"
                    color="error"
                    onClick={() => handleDeletePatient(id)}
                  />
                )
              : getPermission('TRIAGE_DASHBOARD', 'update') && (
                  <PatientActions patient={patient} isActive={isActive} />
                )}
          </MuiBox>
        </MuiTableCell>
      )}
    </TableRow>
  );
}
